import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Input } from '@fiverr-private/forms';
import { appTranslate } from '../../../i18n';
import { LIMITS } from '../../../../consts';
import { darkInput } from '../styles.ve.css';
import type { ContactInfo } from './contactSchema';

interface StepSubmissionProps {
    contact: ContactInfo;
    onChange: (contact: ContactInfo) => void;
}

interface FieldProps {
    label: string;
    required?: boolean;
    children: React.ReactNode;
}

const t = (key: Parameters<typeof appTranslate>[0]) => appTranslate(key) as string;

const Field = ({ label, required, children }: FieldProps) => (
    <Stack direction="column" gap="2" width="100%">
        <Typography as="p" size="b_lg" color="white">
            {label}
            {required && '*'}
        </Typography>
        {children}
    </Stack>
);

export const StepSubmission = ({ contact, onChange }: StepSubmissionProps) => (
    <Stack direction="column" gap="5" width="100%">
        <Stack direction="column" gap="6" width="100%">
            <Field label={t('unusual_way_wizard.submission.name_label')} required>
                <Input
                    className={darkInput}
                    width="100%"
                    type="text"
                    maxLength={LIMITS.name}
                    value={contact.name}
                    placeholder={t('unusual_way_wizard.submission.name_placeholder')}
                    onChange={(e) => onChange({ ...contact, name: e.target.value })}
                />
            </Field>
            <Field label={t('unusual_way_wizard.submission.email_label')} required>
                <Input
                    className={darkInput}
                    width="100%"
                    type="email"
                    value={contact.email}
                    placeholder={t('unusual_way_wizard.submission.email_placeholder')}
                    onChange={(e) => onChange({ ...contact, email: e.target.value })}
                />
            </Field>
            <Field label={t('unusual_way_wizard.submission.location_label')} required>
                <Input
                    className={darkInput}
                    width="100%"
                    type="text"
                    maxLength={LIMITS.location}
                    value={contact.location}
                    placeholder={t('unusual_way_wizard.submission.location_placeholder')}
                    onChange={(e) => onChange({ ...contact, location: e.target.value })}
                />
            </Field>
            <Field label={t('unusual_way_wizard.submission.linkedin_label')}>
                <Input
                    className={darkInput}
                    width="100%"
                    type="text"
                    value={contact.linkedin}
                    placeholder={t('unusual_way_wizard.submission.linkedin_placeholder')}
                    onChange={(e) => onChange({ ...contact, linkedin: e.target.value })}
                />
            </Field>
        </Stack>

        <Typography as="p" size="b_sm" color="grey_700">
            {t('unusual_way_wizard.submission.mandatory_note')}
        </Typography>
    </Stack>
);
